module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"20px\" height=\"20px\" viewBox=\"0 0 20 20\" style=\"enable-background:new 0 0 20 20;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#40404C;} </style><path class=\"st0\" d=\"M18,2.9C18,2.4,17.6,2,17.1,2L11,2l0,0l-8.7,8.7c-0.4,0.4-0.4,1,0,1.3l2.2,2.2l1.4,1.4L8,17.7 c0.4,0.4,1,0.4,1.3,0L18,9V2.9z M13.4,6.6c-0.6-0.6-0.6-1.7,0-2.3c0.6-0.6,1.7-0.6,2.3,0c0.6,0.6,0.6,1.7,0,2.3 C15.1,7.2,14.1,7.2,13.4,6.6z\"></path></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./~/svg-inline-loader?removeSVGTagAttrs=false!./src/img/transactions.svg
 ** module id = 430
 ** module chunks = 0
 **/